module.exports = __webpack_public_path__ + "img/scene-campus.ceef4574.jpg";